var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.625 1.875H2.5C2.15482 1.875 1.875 2.15482 1.875 2.5V6.875C1.875 7.22018 2.15482 7.5 2.5 7.5H5.625C5.97018 7.5 6.25 7.22018 6.25 6.875V2.5C6.25 2.15482 5.97018 1.875 5.625 1.875Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 1.875H9.375C9.02982 1.875 8.75 2.15482 8.75 2.5V4.375C8.75 4.72018 9.02982 5 9.375 5H12.5C12.8452 5 13.125 4.72018 13.125 4.375V2.5C13.125 2.15482 12.8452 1.875 12.5 1.875Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 7.5H9.375C9.02982 7.5 8.75 7.77982 8.75 8.125V12.5C8.75 12.8452 9.02982 13.125 9.375 13.125H12.5C12.8452 13.125 13.125 12.8452 13.125 12.5V8.125C13.125 7.77982 12.8452 7.5 12.5 7.5Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.625 10H2.5C2.15482 10 1.875 10.2798 1.875 10.625V12.5C1.875 12.8452 2.15482 13.125 2.5 13.125H5.625C5.97018 13.125 6.25 12.8452 6.25 12.5V10.625C6.25 10.2798 5.97018 10 5.625 10Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.5502bfb13e86e2807d8f3999d109a8b6.svg";
export { ForwardRef as ReactComponent };